import { render, staticRenderFns } from "./page-dashboard.vue?vue&type=template&id=687bd841"
import script from "./page-dashboard.vue?vue&type=script&lang=ts"
export * from "./page-dashboard.vue?vue&type=script&lang=ts"
import style0 from "./page-dashboard.vue?vue&type=style&index=0&id=687bd841&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports